import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';

import MenuLateral from 'Component/MenuLateral';
import MenuSuperior from 'Component/MenuSuperior';
import Rodape from 'Component/Rodape';

import type { Props } from './index';

const Default = (props: Props): React.ReactElement =>
{
    return (
        <div className="d-flex h-100 flex-nowrap bg-light">
            <MenuLateral />
            <div className="w-100 d-flex flex-column overflow-auto">
                <MenuSuperior />
                <section className="d-flex flex-column flex-grow-1 p-3 p-sm-4">
                    {props.children}
                </section>
                <BrowserView>
                    <Rodape />
                </BrowserView>
                <MobileView style={{ marginBottom: '67px' }} />
            </div>
        </div>
    )
}

export default Default;
